import { render } from "./LockStudy.vue?vue&type=template&id=1a735f0e&scoped=true"
import script from "./LockStudy.vue?vue&type=script&lang=js"
export * from "./LockStudy.vue?vue&type=script&lang=js"

import "./LockStudy.vue?vue&type=style&index=0&id=1a735f0e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a735f0e"]])

export default __exports__